<h2 mat-dialog-title>Mover para "{{ data.nomeDestino }}"</h2>

<mat-dialog-content>
    <p class="descricao-modal">
        Esta etapa exige um motivo. Ele fica registrado no histórico do documento, junto de quem
        moveu e quando.
    </p>

    @if (temMotivos) {
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Motivo</mat-label>
        <mat-select [(ngModel)]="idMotivoTransicao">
            @for (motivo of data.motivos; track motivo.idMotivoTransicao) {
            <mat-option [value]="motivo.idMotivoTransicao">{{ motivo.nome }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Justificativa (opcional)</mat-label>
        <textarea matInput rows="3" [(ngModel)]="justificativa" maxlength="500"></textarea>
    </mat-form-field>
    } @else {
    <!-- Sem motivo cadastrado não há como cumprir a exigência da etapa: mandar o usuário ao
         cadastro é mais útil que um select vazio. -->
    <p class="pv-motivo-vazio">
        Nenhum motivo de transição ativo está disponível para esta etapa. Cadastre um em
        <strong>Configurações &gt;&gt; Vendas &gt;&gt; Motivos de transição</strong> antes de mover o
        documento.
    </p>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" [disabled]="idMotivoTransicao == null" (click)="confirmar()">
        Mover
    </button>
</mat-dialog-actions>
